<ng-container *ngIf="produto != null && grupos.length > 0">
  <div class="additional-groups">
    <div class="additional-group" *ngFor="let grupo of grupos">
      <div class="additional-group__header">
        <div>
          <strong>{{grupo.nome}}</strong>
          <span>{{labelQuantidadeOpcoes(grupo)}}</span>
        </div>

        <span class="badge badge-warning" *ngIf="grupo.obrigatorio">obrigatório</span>
      </div>

      <div class="additional-options">
        <div class="additional-option" *ngFor="let opcao of grupo.opcoes">
          <div class="additional-option__id">
            <i class="fas fa-circle complemento"></i>
            <span>{{opcao.id}}</span>
          </div>

          <div class="additional-option__info">
            <strong><ng-container *ngIf="opcao.codigoPdv">{{opcao.codigoPdv}} - </ng-container>{{opcao.nome}}</strong>
            <span *ngIf="opcao.descricao">{{opcao.descricao}}</span>
          </div>

          <div class="additional-option__price">
            {{opcao.valor | currency:"BRL"}}
          </div>

          <div class="additional-option__actions">
            <button class="btn btn-sm btn-danger" (click)="pausarAdicional(opcao)"
                    *ngIf="opcaoDisponivel(opcao)" [disabled]="processando">
              <i class="far fa-pause-circle" kendoTooltip title="Parar Temporariamente o Adicional"></i> Parar Vendas
            </button>
            <button (click)="ativarAdicional(opcao)" *ngIf="!opcaoDisponivel(opcao)" class="btn btn-sm btn-primary" [disabled]="processando">
              <i class="far fa-play-circle" kendoTooltip title="Ativar Vendas do Adicional"></i> Ativar Vendas
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;height: 400px;" *ngIf="carregando"></div>
  </div>
</ng-container>
